import type { StrapiBaseRequest } from '@/interfaces/strapi';

export const queryParams: StrapiBaseRequest = {
	populate: {
		departamentos: true,
	},
} as const;
